import { render, staticRenderFns } from "./ManagementRegulations.vue?vue&type=template&id=a3293c98&"
import script from "./ManagementRegulations.vue?vue&type=script&lang=js&"
export * from "./ManagementRegulations.vue?vue&type=script&lang=js&"
import style0 from "./ManagementRegulations.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports